import { connect } from 'react-redux';
import { isAdditionalInfoRequired } from '../../redemption.utils';
import CodeFirstPlatformSelection from '../code-first-selection/code-first-platform-selection.component';
import memoizePlatforms from 'utils/memoizePlatforms';
import { savePlatformType } from '../../redemption.actions';
import { redeemGift } from '../../v2/redemption.actions';

import { IRedeemCodeData } from 'types/redemption';
import { Dispatch } from 'types/dispatch';
import {
    ICodeFirstPlatformSelectionDispatchProps,
    ICodeFirstPlatformSelectionStoreProps
} from './сode-first-platform-selection.types';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { State } from 'widgets/redeem/root/root.reducers';
import { PLATFORMS_ORDER } from 'constants/platform';

const mapStateToProps = (state: State): ICodeFirstPlatformSelectionStoreProps => {
    const availablePlatforms = state.redemptionV2?.platforms ?? state.redemption?.codeFirstPlatforms;
    return {
        fetching: state.redemption?.fetching ?? false,
        preselectedPlatformId: state.redemption?.redeemData?.platform!,
        code: state.redemption?.redeemData?.code!,
        availablePlatforms: memoizePlatforms(PLATFORMS_ORDER, availablePlatforms ?? [])(),
        isAdditionalInfoRequired: isAdditionalInfoRequired(state),
        profilePlatforms: state.login?.loginSession?.UbisoftConnectProfiles ?? []
    };
};

const mapDispatchToProps = (dispatch: Dispatch): ICodeFirstPlatformSelectionDispatchProps => ({
    redeemGift: (redeemData: IRedeemCodeData): void => {
        dispatch(redeemGift(redeemData));
    },
    savePlatformType: (platformId: PLATFORM_TYPES): void => {
        dispatch(savePlatformType(platformId));
    }
});

const CodeFirstPlatformSelectionContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CodeFirstPlatformSelection);

export default CodeFirstPlatformSelectionContainer;
